export default __webpack_public_path__ + "static/media/icon_past.cec3324b.svg";